import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__$4 from './DateBadge.vue.js';
import { usePortalStore } from '../../../../store/portal/index.js';
import { useSessionStore } from '../../../../store/portal/sessionStore.js';
import TransitionExpand from '../../../../../../transitions/TransitionExpand/TransitionExpand.js';
import __vue_component__$3 from '../../../../../../transitions/TransitionFadeInDelay/TransitionFadeInDelay.vue.js';
import __vue_component__$1 from '../../../../../../ui/Icon.vue.js';
import __vue_component__$2 from '../../../../../../ui/Loading/Loading.vue.js';
import { delayedComputed } from '../../../../../../../composables/dom.js';
import '@caresend/utils';
import '@caresend/types';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../../../../../router/helpers/initRouter.js';
import '../../../../../../../functions/configuration/icons.js';
import '../../../../../../../database/algoliaConfig/indices.js';
import { preventParentClickAndDefault } from '../../../../../../../functions/preventDefault.js';
import 'mobile-device-detect';
import '../../../../../../../functions/tracking/index.js';

var script = defineComponent({
    name: 'SessionCard',
    components: {
        ButtonComponent: __vue_component__,
        Icon: __vue_component__$1,
        Loading: __vue_component__$2,
        TransitionExpand,
        TransitionFadeInDelay: __vue_component__$3,
        DateBadge: __vue_component__$4,
    },
    props: {
        sessionID: {
            type: String,
            required: true,
        },
        contextID: {
            type: String,
            required: true,
        },
        isActive: {
            type: Boolean,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['click', 'delete'],
    setup(props, { emit }) {
        const sessionStore = useSessionStore();
        const portalStore = usePortalStore();
        const sessionInfo = delayedComputed(() => sessionStore.sessionInfoByID.getRaw(props.sessionID));
        /**
         * If the session item is a draft itinerary, this will return 'Draft'.
         * Otherwise, it will return undefined. Will be used to display the status
         * of the session in the session card. in case there is no date for the icon.
         *
         * could be updated for other types or statuses in the future
         */
        const itineraryStatusCardDraftLabel = computed(() => {
            var _a;
            if (!((_a = sessionInfo.value) === null || _a === void 0 ? void 0 : _a.statusDbRef))
                return undefined;
            // Split the statusDbRef path to get the parts
            const [rmName, id] = sessionInfo.value.statusDbRef.split('/');
            if (!rmName || rmName !== 'itineraries' || !id)
                return undefined;
            const itinerary = portalStore.itineraries.getRaw(id);
            return (itinerary === null || itinerary === void 0 ? void 0 : itinerary.status) === 'draft' ? 'Draft' : undefined;
        });
        const getSessionClasses = () => {
            const classes = [];
            if (props.isActive) {
                classes.push('SessionCard--active');
            }
            if (props.isLoading) {
                classes.push('SessionCard--loading');
            }
            return classes;
        };
        const sessionClasses = computed(() => getSessionClasses());
        const getUserFromSessionInfo = () => {
            var _a, _b;
            if (!((_a = sessionInfo.value) === null || _a === void 0 ? void 0 : _a.userID))
                return;
            return (_b = portalStore.users.get(sessionInfo.value.userID)) !== null && _b !== void 0 ? _b : { info: { picture: sessionInfo.value.img } };
        };
        const user = computed(() => getUserFromSessionInfo());
        const clickDelete = (e) => {
            preventParentClickAndDefault(e);
            emit('delete');
        };
        return {
            clickDelete,
            itineraryStatusCardDraftLabel,
            sessionInfo,
            sessionClasses,
            user,
        };
    },
});

export { script as default };
